import { render, staticRenderFns } from "./LeadPencilIcon.vue?vue&type=template&id=3da10dd3"
import script from "./LeadPencilIcon.vue?vue&type=script&lang=js"
export * from "./LeadPencilIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports